import React from 'react'

const SecurePackage = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={80}
                height={80}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#ffcd9b"
                        fillRule="evenodd"
                        d="M110.639 121.928 174.9 41.169h183.232l64.261 80.759v250.299H110.639z"
                        opacity={1}
                        data-original="#e89e54"
                        className=""
                    />
                    <path
                        fill="#fad1a8"
                        fillRule="evenodd"
                        d="M110.639 121.928h311.754l-64.261-80.759H174.9z"
                        opacity={1}
                        data-original="#faba7b"
                        className=""
                    />
                    <path
                        fill="#60a9eb"
                        fillRule="evenodd"
                        d="M247.382 41.169h38.268l12.5 80.759v79.257l-15.817-23.5-15.817 23.5-15.817-23.5-15.818 23.5v-79.257z"
                        opacity={1}
                        data-original="#fb4455"
                        className=""
                    />
                    <path
                        fill="#ffb56b"
                        fillRule="evenodd"
                        d="M110.639 282.822c9.524-.028 19.02.2 28.459 1.106 32.769 3.061 62.108 14.683 91.786 28.261a15.928 15.928 0 0 0 7.229 1.588h53.716a43.8 43.8 0 0 1 43.087 36.51q33.761-12.16 67.493-24.321a45.966 45.966 0 0 1 19.984-2.523v48.784H110.639z"
                        opacity={1}
                        data-original="#db8c3d"
                        className=""
                    />
                    <path
                        fill="#fad1a8"
                        fillRule="evenodd"
                        d="M428.317 397.824a30.388 30.388 0 0 0-20.607-57.175l-93.459 33.676a28.056 28.056 0 0 0-22.422-44.925h-53.716a31.648 31.648 0 0 1-13.748-3c-78.152-35.8-94.054-26.986-177.222-26.986l.567 130.309c69.618 0 59.7-1.219 119.962 28.913 30.9 16.554 61.8 15.279 92.693 4.366z"
                        opacity={1}
                        data-original="#faba7b"
                        className=""
                    />
                    <path
                        fill="#60a9eb"
                        d="M7.004 268.678h66.643v194.74H7.004z"
                        opacity={1}
                        data-original="#fb4455"
                        className=""
                    />
                    <g fillRule="evenodd">
                        <path
                            fill="#69a7ff"
                            d="M413.01 245.32c-57.089-25.228-73.417-86.8-73.218-144.17l.056-18.822 18.426-3.8A104.661 104.661 0 0 0 407.2 54.067l15.194-13.21 15.194 13.21a104.66 104.66 0 0 0 48.926 24.462l18.425 3.8.061 18.821c.17 57.373-16.129 118.942-73.248 144.17l-9.354 4.139z"
                            opacity={1}
                            data-original="#69a7ff"
                            className=""
                        />
                        <path
                            fill="#c5dcf1"
                            d="M422.393 222.388c46.46-20.551 58.224-73.106 58.054-120.1-22.11-4.564-40.989-14.145-58.054-28.97-17.093 14.821-35.943 24.402-58.082 28.966-.141 47 11.622 99.553 58.082 120.1z"
                            opacity={1}
                            data-original="#d5e3f2"
                            className=""
                        />
                        <path
                            fill="#1975c9"
                            d="M234.881 121.928h63.269v79.257l-15.817-23.5-15.817 23.5-15.817-23.5-15.818 23.5zM50.601 441.903H7.004v21.515h66.643V268.678H50.601v161.036z"
                            opacity={1}
                            data-original="#e82e41"
                            className=""
                        />
                        <path
                            fill="#ffb770"
                            d="M164.582 438.643c-50.145-25.058-51.675-28.432-90.935-28.857v19.956c42.293.283 42.576 3.175 94.025 28.885 30.9 16.554 61.8 15.279 92.693 4.366l167.952-65.169a30.464 30.464 0 0 0 18.283-38.891 33.021 33.021 0 0 0-1.814-4.082 30.487 30.487 0 0 1-19.531 22.989l-167.98 65.168c-30.9 10.942-61.795 12.189-92.693-4.365z"
                            opacity={1}
                            data-original="#f5ad65"
                            className=""
                        />
                        <path
                            fill="#ffb56b"
                            d="M406.8 242.344v82.261a46.229 46.229 0 0 1 15.59-1.162v-73.984l-9.383-4.139q-3.189-1.4-6.207-2.976z"
                            opacity={1}
                            data-original="#db8c3d"
                            className=""
                        />
                        <path
                            fill="#ffb770"
                            d="M342.541 41.169 369.867 75.5a104.939 104.939 0 0 0 11.849-4.677l-23.584-29.65z"
                            opacity={1}
                            data-original="#f5ad65"
                            className=""
                        />
                        <path
                            fill="#4c8fed"
                            d="M492.522 101.15c.2 56.324-15.534 116.674-70.129 142.753-1.02.482-2.069.964-3.09 1.417l-3.146 1.389 6.236 2.75 9.354-4.139c57.119-25.228 73.418-86.8 73.248-144.17l-.057-18.822-18.425-3.8a104.66 104.66 0 0 1-48.926-24.462l-15.194-13.21-6.236 5.414 8.957 7.8c14.457 12.557 30.161 20.579 48.926 24.462l18.425 3.8z"
                            opacity={1}
                            data-original="#4c8fed"
                            className=""
                        />
                    </g>
                    <path
                        d="M511.941 82.307a7 7 0 0 0-5.588-6.836l-18.419-3.8c-17.334-3.584-31.874-10.86-45.753-22.888l-15.193-13.21a7.005 7.005 0 0 0-9.188 0L402.61 48.78a104.951 104.951 0 0 1-18.921 13.236L363.64 36.81a7 7 0 0 0-5.48-2.643H174.927a7 7 0 0 0-5.479 2.642l-64.261 80.761a7 7 0 0 0-1.523 4.359V291.5c-5.284.073-10.829.2-16.746.334l-6.271.14v-23.3a7 7 0 0 0-7-7H7a7 7 0 0 0-7 7v194.747a7 7 0 0 0 7 7h66.645a7 7 0 0 0 7-7v-26.594c29.419.5 34.968 3.308 68.077 20.09 4.671 2.368 9.868 5 15.727 7.933a108.752 108.752 0 0 0 52.138 13.294c14.667 0 29.985-2.852 46.107-8.546a7.66 7.66 0 0 0 .2-.074l167.881-65.17a37.345 37.345 0 0 0 3.166-68.913 38.269 38.269 0 0 0-4.548-1.786v-79.63l5.214-2.3c27.92-12.352 48.672-33.769 61.68-63.655 10.541-24.213 15.826-53.47 15.713-86.97zM66.643 456.419H14V275.681h52.643zm288.14-408.248 15.683 19.716a102.646 102.646 0 0 1-13.575 3.786l-18.454 3.8a7 7 0 0 0-5.591 6.836l-.056 18.8q-.021 7.044.287 13.825h-28.923l-10.31-66.756zm-101.4 0h26.29l10.309 66.756h-46.906zm-11.474 80.76h49.238v49.28l-2.976-4.429a7 7 0 0 0-5.808-3.1 7 7 0 0 0-5.809 3.093l-10.009 14.87-10.009-14.87a7 7 0 0 0-11.617 0l-3.007 4.468zM178.3 48.171h60.912l-10.309 66.756H125.185zm-60.635 80.76h110.242v72.256a7 7 0 0 0 12.811 3.909l10.009-14.87 10.008 14.87a7 7 0 0 0 11.618 0l10-14.863 9.982 14.858a7 7 0 0 0 12.814-3.9v-72.26h28.9c2.129 22.082 6.957 41.9 14.459 59.139 13.009 29.888 33.766 51.305 61.7 63.655l5.184 2.294v77.927a37.306 37.306 0 0 0-10.027 2.118l-78.8 28.384a35.087 35.087 0 0 0-34.74-40.052h-53.713a24.562 24.562 0 0 1-10.829-2.367c-50.838-23.321-76.359-28.128-109.615-28.557zm322.351 232.381a23.443 23.443 0 0 1-14.071 29.9c-.053.02-.107.039-.16.06L257.933 456.43c-32.285 11.377-60.731 10.079-86.956-3.971-.059-.031-.116-.062-.176-.091-5.869-2.934-11.072-5.572-15.746-7.941-34.341-17.406-41.435-21-74.408-21.6V305.984q3.375-.073 6.59-.148c8.533-.195 16.224-.369 23.414-.392h.032c35.678-.109 58.963 3.552 110.775 27.32a38.8 38.8 0 0 0 16.654 3.636h53.717a21.028 21.028 0 0 1 16.83 33.716c-.052.068-.086.143-.135.212-.021.026-.044.048-.065.075a21.037 21.037 0 0 1-16.63 8.148h-87.478a7 7 0 0 0 0 14h87.478a34.917 34.917 0 0 0 26.65-12.308l91.636-33.009a23.433 23.433 0 0 1 29.9 14.074zm-11.064-122.4-6.554 2.89-6.526-2.888c-49.482-21.88-65.105-72.192-68.369-116.962v-.027a7.053 7.053 0 0 0-.068-.925c-.47-6.793-.66-13.454-.641-19.86l.039-13.105 12.89-2.653a112.522 112.522 0 0 0 24.456-8 6.941 6.941 0 0 0 1.108-.531 116.644 116.644 0 0 0 26.507-17.5l10.6-9.217L433 59.358a112.609 112.609 0 0 0 52.1 26.03l12.854 2.649.039 13.11c.17 48.84-11.673 112.388-69.041 137.769zm52.937-143.485A118.152 118.152 0 0 1 426.987 68a7 7 0 0 0-9.19 0 117.975 117.975 0 0 1-54.872 27.422 7 7 0 0 0-5.587 6.832c-.234 64.675 21.284 108.421 62.227 126.507a6.994 6.994 0 0 0 5.657 0c40.923-18.067 62.451-61.811 62.257-126.5a7 7 0 0 0-5.59-6.834zM422.4 214.641c-40.433-19.789-50.327-67.641-51.02-106.779A130.569 130.569 0 0 0 422.4 82.41a130.768 130.768 0 0 0 51.035 25.452c-.718 39.147-10.635 87.008-51.035 106.779zm-12.334-61.712 36.833-36.856a7 7 0 0 1 9.9 9.9l-41.783 41.811a7 7 0 0 1-9.9 0l-17.126-17.121a7 7 0 0 1 9.9-9.9z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className="hovered-path"
                    />
                </g>
            </svg>

        </>
    )
}

export default SecurePackage